import Vue from 'vue'
import Router from 'vue-router'
import Launch from './views/launch/Launch.vue'
import Login from './views/launch/Login.vue'

import Profile from './views/Profile.vue'
// Message
import MessageList from './views/message/MessageList.vue'
import Message from './views/message/Message.vue'
// 內容範本
import ContentTemplateList from './views/content-template/ContentTemplateList.vue'
import ContentTemplateEditor from './views/content-template/ContentTemplateEditor.vue'
// 文章
import PostList from './views/post/PostList.vue'
import PostEditor from './views/post/PostEditor.vue'
// 文章標籤
import PostTagList from './views/post-tag/PostTagList.vue'
// 作品集
import WorkList from './views/work/WorkList.vue'
import WorkEditor from './views/work/WorkEditor.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'launch',
      component: Launch
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    /* 內容編輯器範本 */
    {
      path: '/content-template',
      name: 'content-template-list',
      component: ContentTemplateList
    },
    {
      path: '/content-template/creator',
      name: 'createContentTemplate',
      component: ContentTemplateEditor
    },
    {
      path: '/content-template/editor/:id(\\d+)',
      name: 'updateContentTemplate',
      component: ContentTemplateEditor
    },
    /* Message */
    {
      path: '/message',
      name: 'message-list',
      component: MessageList
    },
    {
      path: '/message/:id(\\d+)',
      name: 'message',
      component: Message
    },
    /* 文章 */
    {
      path: '/post',
      name: 'post-list',
      component: PostList
    },
    {
      path: '/post/creator',
      name: 'createPost',
      component: PostEditor
    },
    {
      path: '/post/editor/:id(\\d+)',
      name: 'updatePost',
      component: PostEditor
    },
    /* 文章標籤 */
    {
      path: '/post-tag',
      name: 'post-tag-list',
      component: PostTagList
    },
    /* 作品集 */
    {
      path: '/work',
      name: 'work-list',
      component: WorkList
    },
    {
      path: '/work/creator',
      name: 'createWork',
      component: WorkEditor
    },
    {
      path: '/work/editor/:id(\\d+)',
      name: 'updateWork',
      component: WorkEditor
    },
    /* 管理員 */
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    }
  ]
})
